import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GenerateObraConcretagemColumnDefinition
 */

type Props = {
  onActionEditar: (idMapaConcretagem: number | null, openState: boolean) => void;
  onActionDeletar: (idMapaConcretagem: number | null, openState: boolean) => void;
  onActionCopiar: (idMapaConcretagem: number | null, openState: boolean) => void;
};

export const GenerateObraConcretagemColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionCopiar,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "RA";
      case 1:
        return "RD";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Rompimento Atrasado";
      case 1:
        return "Rompimento em Dia";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 50,
      width: 50,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
            textSize="small"
          />
        </div>
      )
    },
    {
      field: "enviadoLaboratorio",
      filterable: false,
      headerName: "Enviado Lab.",
      width: 57,
      minWidth: 57,
      sortable: true,
      align: "center",
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
          {params.value}
        </div>
      )
    },
    {
      field: "dataConcretagem",
      filterable: false,
      headerName: "Data da Concretagem",
      width: 85,
      minWidth: 85,
      sortable: true,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value ? dayjs(params.value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    {
      field: "tipoConcreto",
      filterable: false,
      headerName: "Tipo de Concreto",
      width: 120,
      minWidth: 120,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "slumpFlowSolicitado",
      filterable: false,
      headerName: "Slump/Flow Solicitado",
      width: 110,
      minWidth: 110,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resistMAP",
      filterable: false,
      headerName: "Resit (MPA)",
      width: 50,
      minWidth: 50,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "nroNotaFiscal",
      filterable: false,
      headerName: "Nº Nota Fiscal",
      width: 55,
      minWidth: 55,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "qteM3",
      filterable: false,
      headerName: "Qte (M3)",
      width: 42,
      minWidth: 42,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "slumpFlowEncontrado",
      filterable: false,
      headerName: "Slump/Flow Encontrado",
      width: 95,
      minWidth: 95,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "localLancamento",
      filterable: false,
      headerName: "Local do Lançamento",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "nroLote",
      filterable: false,
      headerName: "Nº Lote",
      width: 50,
      minWidth: 50,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "nroLaudo",
      filterable: false,
      headerName: "Nº laudo",
      width: 50,
      minWidth: 50,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resultadoSeteDias",
      filterable: false,
      headerName: "Resultado 7 dias",
      width: 60,
      minWidth: 60,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resultadoQuatorzeDias",
      filterable: false,
      headerName: "Resultado 14 dias",
      width: 60,
      minWidth: 60,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resultadoVinteOitoDias",
      filterable: false,
      headerName: "Resultado 28 dias",
      width: 60,
      minWidth: 60,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resultadoSessentaTresDias",
      filterable: false,
      headerName: "Resultado 63 dias",
      width: 60,
      minWidth: 60,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resultadoElasticidadeVinteOitoDias",
      filterable: false,
      headerName: "Elasticidade 28 dias",
      width: 60,
      minWidth: 60,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "aprovado",
      filterable: false,
      headerName: "Aprovado?",
      width: 72,
      minWidth: 72,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "arquivo",
      filterable: false,
      headerName: "Arquivo",
      width: 55,
      minWidth: 55,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "responsavel",
      filterable: false,
      headerName: "Aprovado Por?",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-[0.75rem]">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "aprovacaoFinal",
      filterable: false,
      headerName: "Aprovação Final",
      width: 95,
      minWidth: 95,
      sortable: false,
      align: "center",
      valueGetter: (_, row) => ({
        aprovFinalDate: row.aprovFinalDate,
        aprovFinalFuncionario: row.aprovFinalFuncionario
      }),
      renderCell: ({ value: { aprovFinalDate, aprovFinalFuncionario } }) => {
        return (
          <div className="w-full h-full flex flex-col justify-center items-center">
            <div className="text-[0.55rem] font-bold">{aprovFinalDate && dayjs(aprovFinalDate).local().format("DD/MM/YY HH:mm")}</div>
            <div className="text-[0.65rem] font-bold">{aprovFinalFuncionario}</div>
          </div>
        );
      }
    },
    {
      field: 'idMapaConcretagem',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 115,
      minWidth: 115,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-0">
            <IconButton
              onMouseDown={e => {
                if (e.button === 1) {
                  onActionEditar(params.value, true);
                } else {
                  onActionEditar(params.value, e.ctrlKey);
                }
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={20} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={20} className="text-red-500" />
            </IconButton>

            <IconButton onClick={() => onActionCopiar(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopy" size={20} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}